// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"647cd976","453":"56601cd9","455":"212c03ab","977":"c7574997"}[chunkId] + ".chunk.js";
};